/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'sidebar.smartstock': 'Smart stock',
    'sidebar.clientes': 'customers',
    'clientes.agregarcustomers': 'Create customers',
    'clientes.modificarcustomers': 'Edit customers',
    'clientes.eliminarcustomers': 'Delete customers',
    'clientes.clienteId': 'Customer Id',
    'clientes.empresaId': ' Company Id',
    'clientes.documento': 'Document',
    'clientes.descripcionCliente': 'Description',
    'clientes.descripcionSucursal': ' Branch Description',
    'clientes.descripcionTipoCliente': 'Client type',
    'clientes.descripcionCiudad': 'City',
    'clientes.diasVencimiento': 'Expiration days',
    'clientes.tipoClienteId': 'Customer Type',
    'clientes.ciudadId': 'City',
    'clientes.nombreContacto': ' Contact Name',
    'clientes.telefono': ' Phone',
    'clientes.direccion': ' Address',
    'clientes.correo': ' Mail',
    'clientes.codigoBarras': ' Barcode',
    'clientes.principal': ' Main',
    'clientes.estado': ' State',
    'clientes.clienteSeleccionado': 'Client',
    'clientes.customers': 'customers',
    'clientes.vercustomers': 'View customers',
    'clientes.mensaje.municipiosNoEncontrados': 'No cities found',
    'clientes.alerta.correoInvalido': 'The email entered is not valid',
    'clientes.alerta.eliminarClientePrincipal':
        'Are you sure you want to delete this client, all associated branches will be deleted?',
    'clientes.TipoClienteInactivo': 'Registration type inactive client, select a new one',
};
